export * from './pattern-information.interface';
